// extracted by mini-css-extract-plugin
export var redoItem = "_ok-1";
export var redoTrigger = "_ok-0";